import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const PartnershipForm = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    partnershipType: 'sponsorship',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // TODO: 백엔드 API 연동 필요
    // POST /api/partnerships
    // Body: formData
    console.log('Partnership form submitted:', formData);

    // 임시로 이메일 전송 (emailjs 활용 가능)
    // emailjs를 이용한 이메일 전송 로직 추가 가능

    setSubmitted(true);
    setTimeout(() => {
      setFormData({
        companyName: '',
        contactPerson: '',
        email: '',
        phone: '',
        partnershipType: 'sponsorship',
        message: '',
      });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="partnership-form">
      <h3>{t('donation.partnership.title')}</h3>
      <p>{t('donation.partnership.description')}</p>

      {submitted ? (
        <div className="form-success">
          <p>{t('donation.partnership.successMessage')}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('donation.partnership.companyName')}</label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>{t('donation.partnership.contactPerson')}</label>
            <input
              type="text"
              name="contactPerson"
              value={formData.contactPerson}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>{t('donation.partnership.email')}</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>{t('donation.partnership.phone')}</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>{t('donation.partnership.type')}</label>
            <select
              name="partnershipType"
              value={formData.partnershipType}
              onChange={handleChange}
            >
              <option value="sponsorship">{t('donation.partnership.types.sponsorship')}</option>
              <option value="equipment">{t('donation.partnership.types.equipment')}</option>
              <option value="collaboration">{t('donation.partnership.types.collaboration')}</option>
              <option value="other">{t('donation.partnership.types.other')}</option>
            </select>
          </div>

          <div className="form-group">
            <label>{t('donation.partnership.message')}</label>
            <textarea
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="submit-btn">
            <FontAwesomeIcon icon={faPaperPlane} /> {t('donation.partnership.submit')}
          </button>
        </form>
      )}
    </div>
  );
};

export default PartnershipForm;
